<script>
import {
  cadastrar,
  find, gerarPdfAtendimento
} from '../../../../../domain/policia-civil/notificacao-atendimento/services/notificacao-atendimento'
import {isArray, debounce} from 'lodash'
import {VueMaskDirective as mask} from 'v-mask'
import estadosBr from '../../../../_default/utils/estados-brasileiros'
import {vinculos, origens} from '../../../../../domain/grv/helpers/helpers-notificacao'
import SeguradorasService from '../../../../../domain/policia-civil/seguradora/services/seguradora'
import {buscaCep, custos} from '../../../../../domain/grv/services'
import moment from 'moment'
import {VMoney} from 'v-money'
import {REAL_BRL} from '../../../../../utils/helpers/money'
import {mapGetters} from 'vuex'
import ACL from '../../../../../domain/acl/tmp-acl'
import {validaDocumento} from '../../../../../utils/helpers/validators'

export default {
  name: 'nova-cadastro-notificacao-atendimento',
  directives: {mask, money: VMoney},
  props: {
    grv: {
      required: true,
      type: Object
    },
    atendimentoId: {
      required: false,
      type: Number
    }
  },
  data () {
    return {
      money: REAL_BRL,
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      documentoError: null,
      data: {
        id: null,
        origem: null,
        email: null,
        tipoDocumento: 1,
        cpf: '',
        cnpj: '',
        rg: null,
        telefone1: null,
        telefone2: null,
        telefone3: null,
        idNextel: null,
        filaAtendimento: null,
        dataAgendamento: null,
        dataNotificacao: null,
        gratuidade: null,
        diarias: false,
        periodoDiariasInicio: null,
        periodoDiariasFim: null,
        valorDiarias: null,
        valorTaxaIss: null,
        observacoes: null,
        veiculoSegurado: false,
        apoliceSinistro: null,
        vinculo: null,
        nome: null,
        logradouro: null,
        numero: null,
        complemento: null,
        cep: null,
        uf: null,
        cidade: null,
        bairro: null,
        seguradora: null,
        grv: null,
        lavarVeiculo: false
      },
      horaAgendamento: '',
      quantidadeDiarias: 0,
      valorDiarias: 0,
      valorTotal: 0,
      valorReboque: 0,
      vinculos,
      origens,
      seguradoras: []
    }
  },
  computed: {
    estadosBr () {
      return estadosBr
    },
    ...mapGetters(['isLogged', 'currentUser']),
    ACL () {
      return ACL
    },
    podeAdicionarAtendimento () {
      let length = 0
      if (this.grv && this.grv.atendimentos) {
        length = this.grv.atendimentos.length
      }
      return !length || ACL.check('adicionar_atendimento_grv_extra', this.currentUser.id)
    },
    podeEditarAtendimento () {
      return ACL.check('editar_atendimento_grv', this.currentUser.id)
    }
  },
  created () {
    this.atendimentoId && this.$parent.loading(true)
    this.carregarSeguradoras()
    this.start()
  },
  activated () {
  },
  destroyed () {
  },
  watch: {},
  methods: {
    start () {
      this.data.grv = this.grv.id
      if (this.atendimentoId) {
        find(this.atendimentoId)
          .then((response) => {
            this.isLoaded = true
            const data = response.data

            const formataData = date => date ? moment(date.date).format('L LT') : null

            data.dataNotificacao = formataData(data.dataNotificacao)
            data.dataNotificacao = data.dataNotificacao ? data.dataNotificacao.split(' ')[0] : null

            data.gratuidade = formataData(data.gratuidade)
            data.gratuidade = data.gratuidade ? data.gratuidade.split(' ')[0] : null

            data.dataAgendamento = formataData(data.dataAgendamento)
            const dataAgendamento = data.dataAgendamento ? data.dataAgendamento.split(' ') : null
            if (dataAgendamento) {
              data.dataAgendamento = dataAgendamento[0]
              this.horaAgendamento = dataAgendamento[1]
            }

            data.periodoDiariasInicio = formataData(data.periodoDiariasInicio)

            data.periodoDiariasFim = formataData(data.periodoDiariasFim)
            data.periodoDiariasFim = data.periodoDiariasFim ? data.periodoDiariasFim.split(' ')[0] : null

            data.seguradora = data.seguradora ? data.seguradora.id : null

            this.data = data

            this.carregarCustos()
            // this.ajustaValores()

            this.inicializarTipoDocumento()

            this.$parent.loading(false)
            console.log(response)
          })
          .catch((response) => {
            console.log(response)
            this.$parent.loading(false)
          })
      } else {
        this.isLoaded = true
      }
    },
    ajustaValores (inversed) {
      inversed = inversed || false
      if (inversed) {
        console.log('Inversed fields to data')
      } else {
        this.data.tipoPolicial = (typeof this.data.tipoPolicial['id'] !== 'undefined') ? this.data.tipoPolicial['id'] : this.data.tipoPolicial
      }
    },
    validaDocumento () {
      this.documentoError = null

      const documento = this.data.tipoDocumento === 1 ? this.data.cpf : this.data.cnpj

      if (documento && !validaDocumento(documento)) {
        this.documentoError = this.data.tipoDocumento === 1 ? 'CPF inválido' : 'CNPJ inválido'
        return false
      }

      return true
    },
    handleTipoDocumentoChange (event) {
      this.data.tipoDocumento = parseInt(event.target.value)
      if (this.data.tipoDocumento === 1) {
        this.data.cnpj = ''
      } else {
        this.data.cpf = ''
      }
      this.documentoError = null
    },
    inicializarTipoDocumento () {
      if (this.data.cnpj) {
        this.data.tipoDocumento = 2
      } else {
        this.data.tipoDocumento = 1
      }
    },
    carregarCustos (evt) {
      if (evt && !this.data.dataNotificacao) {
        alert('Necessário inserir a data da notificação')
        return
      }
      const dataNotificacao = this.data.dataNotificacao.split('/').reverse().join('-')
      const dataDiariasInicio = this.data.periodoDiariasInicio && this.data.periodoDiariasInicio.split('/').reverse().join('-')
      const dataDiariasFim = this.data.periodoDiariasFim && this.data.periodoDiariasFim.split('/').reverse().join('-')
      const dataGratuidade = this.data.gratuidade && this.data.gratuidade.split('/').reverse().join('-')

      custos(this.grv.id, dataNotificacao, dataDiariasInicio, dataDiariasFim, dataGratuidade)
        .then(response => {
          const {base, custos} = response.data
          const data = this.data

          const formataData = date => date ? moment(date.date).format('L LT') : null

          data.gratuidade = formataData(base.dataLimiteGratuidade)
          this.quantidadeDiarias = base.diariasNaoPagas
          this.valorDiarias = parseFloat(base.valorDiarias).toFixed(2)
          this.valorTotal = parseFloat(base.saldoDevedor).toFixed(2)
          this.valorReboque = custos.valorReboque && custos.valorReboque.toFixed(2) || 0
        })
        .catch(error => {
          console.log(error)
          alert('Ocorreu um erro ao calcular diárias')
        })
    },
    submit () {
      if (!this.atendimentoId && !this.podeAdicionarAtendimento) {
        return alert('Atenção: já existe um atendimento registrado para essa GRV. Você não tem permissão para adicionar novos.')
      }
      if (this.atendimentoId && !this.podeEditarAtendimento) {
        return alert('Atenção: Você não tem permissão para editar este atendimento.')
      }
      if (!this.validaDocumento()) {
        return alert('Por favor, insira um documento válido.')
      }
      this.data.grv = this.grv.id
      this.cadastroError = null
      this.atualizadoSucesso = false
      this.$parent.loading(true)
      const data = JSON.parse(JSON.stringify(this.data))

      data.dataAgendamento = `${data.dataAgendamento} ${this.horaAgendamento}`

      cadastrar(data, this.atendimentoId).then((response) => {
        let callbackEnd = () => {
          this.$bar.finish()
          this.$parent.loading(false)
          if (this.atendimentoId) {
            // Continua na mesma tela de edição
            // this.$nextTick(() => {
            this.atualizadoSucesso = true
            this.$refs.sucessMsg.focus()
            this.start()
            // })
          } else {
            // Redirecionr para tela de visualização
            // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
            this.$refs.sucessMsg.focus()
            this.atualizadoSucesso = true
          }
          this.$emit('finishSubmit', true)
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$parent.loading(false)
        this.cadastroError = this.printError(response.data.errors)
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    carregarSeguradoras () {
      SeguradorasService.list(10000, 1, '')
        .then(response => {
          this.seguradoras = response.data.result
        })
        .catch(error => {
          alert('Erro ao carregar as unidades policiais')
          console.log(error)
        })
    },
    pesquisarCep: debounce(function () {
      let cep = String(this.data.cep).replace(/\D/g, '')
      if (cep.length !== 8) return
      buscaCep(cep)
        .then(({data}) => {
          this.data.logradouro = data.logradouro
          this.data.bairro = data.bairro
          this.data.cidade = data.localidade
          this.data.complemento = data.complemento
          this.data.uf = data.uf
          this.$refs.enderecoNumero.focus()
        })
        .catch((error) => {
          console.log(error)
        })
    }, 300),
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    },
    calcularLimiteGratuidade (dataBase = null, quantidadeDias = 1, iniciarContagemPelaDataBase = false) {
      if (dataBase.length < 10) return

      const isFimDeSemana = data => {
        const SABADO = 6
        const DOMINGO = 0
        const diaDaSemana = data.getUTCDay()
        return diaDaSemana === SABADO || diaDaSemana === DOMINGO
      }

      dataBase = new Date(dataBase.split('/').reverse().join('-') + ' 00:00')

      const proximosDiasUteis = []
      let counter = 0
      let tamanhoArrayDiasUteis = 0

      if (iniciarContagemPelaDataBase && !isFimDeSemana(dataBase)) {
        --quantidadeDias
      }

      while (tamanhoArrayDiasUteis !== quantidadeDias) {
        counter += 1

        const proximoDia = new Date(dataBase.getTime())
        proximoDia.setUTCDate(dataBase.getUTCDate() + counter)

        if (isFimDeSemana(proximoDia)) {
          continue
        }

        proximosDiasUteis.push(proximoDia)
        tamanhoArrayDiasUteis = proximosDiasUteis.length
      }

      const dataGratuidade = proximosDiasUteis[tamanhoArrayDiasUteis - 1]
      this.data.gratuidade = `${String(dataGratuidade.getUTCDate()).padStart(2, '0')}/${String(dataGratuidade.getUTCMonth() + 1).padStart(2, '0')}/${dataGratuidade.getUTCFullYear()}`
    },
    gerarPdf () {
      this.$parent.loading(true)
      gerarPdfAtendimento(this.data.id)
        .then(response => {
          this.$parent.loading(false)
          this.createDownloadLink(response.data, `ATENDIMENTO_GRV_${this.grv.numero}.pdf`)
        })
        .catch(error => {
          console.log(error)
          alert('Ocorreu um erro ao gerar o arquivo. Contate o suporte.')
          this.$parent.loading(false)
        })
    },
    createDownloadLink (data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Notificação de Atendimento</h1></div>
          <div class="col-sm-6">
            <!--<router-link :to="{name: 'policiacivil.roubo-furto.cadastro-notificacao-processo.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>-->
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="!atendimentoId && !podeAdicionarAtendimento"
                 class="alert alert-danger">
              <h5 class="m-b-sm font-bold">
                <i class="fa fa-exclamation-triangle"></i> Atenção: já existe um atendimento registrado para essa GRV.
                Você não tem permissão para adicionar novos.
              </h5>
            </div>

            <div tabindex="-1" ref="error" v-if="atendimentoId && !podeEditarAtendimento" class="alert alert-danger">
              <div class="m-b-sm font-bold">
                <i class="fa fa-exclamation-triangle"></i> Você não tem permissão para editar este atendimento.
              </div>
            </div>

            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{ printError(erro) }}</p>
            </div>

            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso"
                 class="alert alert-success">
              <div class="font-bold">{{ atendimentoId && 'Atualizado' || 'Cadastrado' }} com sucesso!</div>
            </div>
            <div class="col-sm-12 col-xs-12 m-b" v-if="data.id">
              <h1 class="font-thin h3">
                <button type="button" class="btn btn-default btn-md m-l-xs pull-right" @click="gerarPdf">
                  <i class="fa fa-print"></i> Imprimir
                </button>
              </h1>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">

              <input type="hidden" class="form-control" v-model="data.grv" required/>

              <div class="form-group">
                <label class="col-sm-1 control-label" for="">GRV</label>
                <div class="col-sm-2"><input type="text" class="form-control" :value="grv.numero" disabled/></div>
                <label class="col-sm-1 control-label">Origem</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.origem" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="origem.id" v-for="origem in origens">{{ origem.nome }}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-1 control-label" for="">Placa</label>
                <div class="col-sm-2"><input type="text" class="form-control"
                                             :value="grv.tipoProcesso === 1 ? grv.placaOriginal : grv.placa" disabled/>
                </div>
                <label class="col-sm-1 control-label">Vínculo</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.vinculo" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="vinculo.id" v-for="vinculo in vinculos">{{ vinculo.nome }}</option>
                  </select>
                </div>
              </div>

              <!--<div class="form-group">
                <label class="col-sm-4 control-label"></label>
                <div class="col-sm-8">
                  <button><i class="fa fa-copy"></i> Copiar dados</button>
                </div>
              </div>-->

              <div class="form-group">
                <label class="col-sm-1 control-label" for="">Chassi</label>
                <div class="col-sm-2"><input type="text" class="form-control" :value="grv.chassi" disabled/></div>
                <label class="col-sm-1 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome" required/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-1 control-label" for="">Marca / Modelo</label>
                <div class="col-sm-2"><input type="text" class="form-control" :value="grv.marca" disabled/></div>

                <div class="col-sm-2">
                  <select required v-model="data.tipoDocumento" class="form-control" @change="handleTipoDocumentoChange">
                    <option :value=1>CPF</option>
                    <option :value=2>CNPJ</option>
                  </select>
                </div>

                <div class="col-sm-4">
                  <input
                    v-if="data.tipoDocumento === 1"
                    autocomplete="off"
                    required
                    id="documentoPagador"
                    type="text"
                    v-model="data.cpf"
                    v-mask="'###.###.###-##'"
                    class="form-control"
                    @blur="validaDocumento"
                    name="cpf"
                  />
                  <input
                    v-else
                    autocomplete="off"
                    required
                    id="documentoPagador"
                    type="text"
                    v-model="data.cnpj"
                    v-mask="'##.###.###/####-##'"
                    class="form-control"
                    @blur="validaDocumento"
                    name="cnpj"
                  />
                  <span v-if="documentoError" class="text-danger">{{ documentoError }}</span>
                </div>
              </div>


              <div class="form-group">
                <label class="col-sm-4 control-label">RG</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.rg"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cep" v-mask="'##.###-###'"
                         @keyup="pesquisarCep"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Logradouro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.logradouro"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Número</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" ref="enderecoNumero" v-model="data.numero"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Bairro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.bairro"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complemento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">UF</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.uf">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{ estado.nome }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cidade"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label"></label>
                <div class="col-sm-2">
                  <label class="control-label">Telefone 1</label>
                  <input type="text" class="form-control" v-model="data.telefone1" v-mask="'(##) #####-####'"
                         placeholder="(00) 00000-0000"/>
                </div>
                <div class="col-sm-2">
                  <label class="control-label">Telefone 2</label>
                  <input type="text" class="form-control" v-model="data.telefone2" v-mask="'(##) #####-####'"
                         placeholder="(00) 00000-0000"/>
                </div>
                <div class="col-sm-2">
                  <label class="control-label">Telefone 3</label>
                  <input type="text" class="form-control" v-model="data.telefone3" v-mask="'(##) #####-####'"
                         placeholder="(00) 00000-0000"/>
                </div>
              </div>

              <hr>
              <div class="form-group">
                <label class="col-sm-4 control-label" style="font-weight: bold;">Agendamento</label>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Fila de Atendimento</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.filaAtendimento">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="1">Agendamento</option>
                    <option :value="2">Rodando</option>
                  </select>
                </div>
              </div>

              <div class="form-group m-t m-b">
                <label class="col-sm-4 control-label"></label>
                <div class="col-sm-4">
                  <label class="control-label">Data Agendamento</label>
                  <input id="dataAgendamento" type="text" class="form-control" placeholder="dd/mm/yyyy"
                         v-mask="'##/##/####'" v-model="data.dataAgendamento"/>
                </div>
                <div class="col-sm-4">
                  <label class="control-label">Hora Agendamento</label>
                  <input id="horaAgendamento" type="text" class="form-control" placeholder="hh:mm" v-mask="'##:##'"
                         v-model="horaAgendamento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label"></label>
                <div class="col-sm-4">
                  <label class="control-label">Data Notificação</label>
                  <input id="dataNotificacao"
                         type="text"
                         class="form-control"
                         placeholder="dd/mm/yyyy"
                         v-mask="'##/##/####'"
                         v-model="data.dataNotificacao"
                         @keyup="calcularLimiteGratuidade(data.dataNotificacao, 3)"
                  />
                </div>
                <div class="col-sm-4">
                  <label class="control-label">Gratuidade</label>
                  <input id="gratuidade" type="text" class="form-control" placeholder="dd/mm/yyyy" v-mask="'##/##/####'"
                         v-model="data.gratuidade"/>
                </div>
                <!--<div class="col-sm-4">
                  <u-button class="btn m-b-xs m-r-xs btn-info" @click="carregarCustos($event)">Calcular diárias</u-button>
                </div>-->
              </div>

              <div class="form-group">
                <label for="has-diarias" class="col-sm-4 control-label">Diárias</label>
                <div class="col-sm-8">
                  <input id="has-diarias" type="checkbox" v-model="data.diarias"/>
                </div>
              </div>

              <div v-if="data.diarias">

                <div class="form-group">
                  <label class="col-sm-4"></label>
                  <div class="col-sm-4">
                    <label class="control-label">Início do Período de Diárias</label>
                    <input id="periodoDiariasInicial" type="text" class="form-control" placeholder="dd/mm/yyyy"
                           v-mask="'##/##/####'" v-model="data.periodoDiariasInicio"/>
                  </div>
                  <div class="col-sm-4">
                    <label class="control-label">Fim do Período de Diárias</label>
                    <input id="periodoDiariasFinal" type="text" class="form-control" placeholder="dd/mm/yyyy"
                           v-mask="'##/##/####'" v-model="data.periodoDiariasFim"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4"></label>
                  <div class="col-sm-4">
                    <u-button class="btn m-b-xs m-r-xs btn-info" @click="carregarCustos($event)">Calcular diárias com
                      base na data de fim do período
                    </u-button>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Quantidade de Diárias</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="quantidadeDiarias" disabled/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Valor das Diárias</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="valorDiarias" v-money="money" disabled/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Valor do Reboque</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="valorReboque" v-money="money" disabled/>
                  </div>
                </div>

                <!--<div class="form-group">
                  <label class="col-sm-4 control-label">% ISS</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="data.porcentagemIss"/>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Valor ISS</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="data.valorIss"/>
                  </div>
                </div>-->

                <div class="form-group">
                  <label class="col-sm-4 control-label">Valor Total</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="valorTotal" v-money="money" disabled/>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="veiculoSegurado" class="col-sm-4 control-label">Veículo segurado</label>
                <div class="col-sm-8">
                  <input id="veiculoSegurado" type="checkbox" v-model="data.veiculoSegurado"/>
                </div>
              </div>

              <div v-if="data.veiculoSegurado">
                <div class="form-group">
                  <label class="col-sm-4 control-label">Seguradora</label>
                  <div class="col-sm-8">
                    <select id="seguradora" v-model="data.seguradora" class="form-control">
                      <option :value="null" disabled>Selecione</option>
                      <option :value="seguradora.id" v-for="seguradora in seguradoras" :key="seguradora.id">
                        {{ seguradora.nome }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">Apólice Sinistro</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="data.apoliceSinistro"/>
                  </div>
                </div>

                <!--<div class="form-group">
                  <label class="col-sm-4 control-label">Deseja lavar o veículo</label>
                  <div class="col-sm-8">
                    <select class="form-control" v-model="data.lavarVeiculo">
                      <option :value="null" disabled>Selecione</option>
                      <option :value="1">Sim</option>
                      <option :value="0">Não</option>
                    </select>
                  </div>
                </div>-->
              </div>

              <div class="form-group">
                <label for="observacoes" class="col-sm-4 control-label">Observações</label>
                <div class="col-sm-8">
                  <textarea id="observacoes" v-model="data.observacoes" rows="7" class="form-control"
                            style="resize: none;"></textarea>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper" v-if="ACL.check('restrito_visitante', currentUser.id)">
                <u-button type="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('finishSubmit')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoCadastroNotificacaoProcesso.vue?6dfeadea